export const shipping_status_options = [
  { label: "To Be Dispatched", value: 1, className: "notDispatched" },
  { label: "Dispatched", value: 2, className: "dispatched" },
];
